export default {
  props: {

  },
};
